import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowRight } from "lucide-react";

export default function SubscribeForm({ variant = "default" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/subscribe", { email });
      if (data.already_subscribed) toast.info("You're already on the list.");
      else toast.success("Subscribed. New posts land in your inbox.");
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 3000);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  if (variant === "inline") {
    return (
      <form onSubmit={submit} className="flex gap-2 max-w-md" data-testid="subscribe-form-inline">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@company.com"
          data-testid="subscribe-email-input"
          className="flex-1 bg-transparent border border-border rounded-full px-5 py-3 text-sm outline-none focus:border-foreground transition-colors"
        />
        <button
          disabled={loading}
          data-testid="subscribe-submit-btn"
          className="inline-flex items-center gap-1 px-5 py-3 rounded-full bg-foreground text-background font-mono text-xs uppercase tracking-[0.2em] disabled:opacity-50"
        >
          {loading ? "…" : subscribed ? "✓" : <>Subscribe <ArrowRight className="w-3.5 h-3.5" /></>}
        </button>
      </form>
    );
  }

  return (
    <div className="p-8 lg:p-12 rounded-3xl border border-border bg-card" data-testid="subscribe-form">
      <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-accent mb-4">
        <Mail className="w-3.5 h-3.5" /> [ email me when i publish ]
      </div>
      <h3 className="font-serif text-2xl sm:text-3xl tracking-tight max-w-xl">
        Field notes on DFIR → GRC, delivered when I ship them.
      </h3>
      <p className="mt-3 text-muted-foreground text-sm max-w-xl">
        No spam, no drip-nurture nonsense. Just an email when I publish a new insight — usually every few weeks.
      </p>
      <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-lg">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@company.com"
          data-testid="subscribe-email-input"
          className="flex-1 bg-transparent border border-border rounded-full px-5 py-3 text-sm outline-none focus:border-foreground transition-colors"
        />
        <button
          disabled={loading}
          data-testid="subscribe-submit-btn"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-foreground text-background font-mono text-xs uppercase tracking-[0.2em] disabled:opacity-50"
        >
          {loading ? "Subscribing…" : "Subscribe →"}
        </button>
      </form>
    </div>
  );
}
